export const calculateAgeBreakdown = (dobInput) => {

    console.log("dobInput",dobInput)
  try {
    const dob = dobInput instanceof Date ? dobInput : new Date(dobInput);
    if (Number.isNaN(dob.getTime())) return { years: 0, months: 0, days: 0 };

    // Normalize both dates to LOCAL midnight (avoid timezone/time issues)
    const today = new Date();
    const todayLocal = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const dobLocal = new Date(dob.getFullYear(), dob.getMonth(), dob.getDate());

    if (dobLocal > todayLocal) return { years: 0, months: 0, days: 0 };

    let years = todayLocal.getFullYear() - dobLocal.getFullYear();
    let months = todayLocal.getMonth() - dobLocal.getMonth();
    let days = todayLocal.getDate() - dobLocal.getDate();

    // Borrow days from previous month if needed
    if (days < 0) {
      const lastDayPrevMonth = new Date(todayLocal.getFullYear(), todayLocal.getMonth(), 0).getDate();
      days += lastDayPrevMonth;
      months -= 1;
    }

    // Borrow months from previous year if needed
    if (months < 0) {
      months += 12;
      years -= 1;
    }

    if (years < 0) return { years: 0, months: 0, days: 0 };

    return { years, months, days };
  } catch (e) {
    console.error("calculateAgeBreakdown error:", e);
    return { years: 0, months: 0, days: 0 };
  }
};


export const formatAgeBreakdown = (age) => {
  try {
    if (!age) return "-";

    const y = Number(age.years) || 0;
    const m = Number(age.months) || 0;
    const d = Number(age.days) || 0;

    const parts = [];

    // show years only if > 0
    if (y > 0) parts.push(`${y} yr${y > 1 ? "s" : ""}`);

    // show months if > 0 OR if years is 0 (for babies)
    if (m > 0 || y === 0) parts.push(`${m} mo${m > 1 ? "s" : ""}`);

    // show days if > 0 OR if years & months are 0 (newborn)
    if (d > 0 || (y === 0 && m === 0)) parts.push(`${d} day${d > 1 ? "s" : ""}`);

    return parts.join(" ");
  } catch (e) {
    console.error("formatAgeBreakdown error:", e);
    return "-";
  }
};